import { useTranslation } from 'react-i18next';
import type { CardConnectionStatus } from '../../lib/dashboard/screenStatus';

export type { CardConnectionStatus };

type StatusPillProps = {
  status: CardConnectionStatus;
};

const CONNECTION_TONE: Record<CardConnectionStatus, string> = {
  online: 'text-ok',
  offline: 'text-bad',
  unknown: 'text-muted',
  unpaired: 'text-muted',
};

const CONNECTION_DOT: Record<CardConnectionStatus, string> = {
  online: 'bg-ok',
  offline: 'bg-bad',
  unknown: 'bg-muted',
  unpaired: 'bg-muted',
};

export function StatusPill({ status }: StatusPillProps) {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border border-line bg-canvas px-2.5 py-1 text-[11.5px] font-semibold ${CONNECTION_TONE[status]}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${CONNECTION_DOT[status]}`} />
      {t(`connection.${status}`)}
    </span>
  );
}
